import Autocomplete, {createFilterOptions} from "@material-ui/lab/Autocomplete";
import TextField from "@material-ui/core/TextField";
import React from "react";
import {useTranslation} from "react-i18next";

const filter = createFilterOptions();

const ChipsSelect = (props) => {
    const {input, options, label, customOnChange, dropdown, simulateTextInput, ...custom} = props
    const {t} = useTranslation()
    return <Autocomplete
        options={options}
        getOptionLabel={(option) => option.heName || ''}
        renderOption={(option) => (option.label && <span>{option.label}</span>) || option.heName || ''}
        onChange={(none, newValue) => {
            input.onChange((typeof newValue === "string") ? {_id: 0, heName: newValue} : newValue)
            customOnChange && customOnChange(newValue)
        }}
        value={input.value || []}
        noOptionsText={t('no-options')}
        renderInput={(params) => (
            <TextField
                {...params}
                variant="outlined"
                label={label}
                placeholder={label}
            />)}
        selectOnFocus
        filterOptions={(options, params) => {
            const filtered = filter(options, params);
            if (params.inputValue !== '' && !dropdown) {
                filtered.push({
                    _id: 0,
                    heName: params.inputValue,
                    label: `${t('add')} "${params.inputValue}"`,
                });
            }

            return filtered;
        }}
        {...custom}
    />
}
export default ChipsSelect;